{
  "title": "Opérations - Messages",
  "tabTitles": {
    "urgent": "🔴 ({{count}}) Boîte de réception Opérations",
    "actionable": "({{count}}) Boîte de réception Opérations",
    "default": "Opérations - Boîte",
    "appDefault": "AirPlx"
  },
  "header": {
    "timeFilters": {
      "today": "Auj.",
      "tomorrow": "Demain",
      "week": "Cette semaine",
      "all": "Tous"
    },
    "statusLabels": {
      "allSetToday": "Prêt pour aujourd'hui",
      "nothingTomorrow": "Rien demain",
      "clearForWeek": "Libre pour la semaine",
      "allCaughtUp": "Vous êtes à jour !",
      "arrivalsToday": "{{count}} arrivée aujourd'hui",
      "arrivalsTomorrow": "{{count}} arrivée demain",
      "arrivalsWeek": "{{count}} arrivée cette semaine",
      "total": "{{count}} au total"
    },
    "newTails": "{{count}} nouveau",
    "searchPlaceholder": "Rechercher immat., type, opérateur...",
    "refreshStatus": {
      "refreshing": "Actualisation...",
      "updated": "Mis à jour {{timeAgo}}",
      "justNow": "à l'instant",
      "secondsAgo": "Il y a {{count}}s",
      "minuteAgo": "1 min",
      "minutesAgo": "Il y a {{count}}m"
    }
  },
  "groups": {
    "unknownAircraft": {
      "title": "NOUV. AVIONS",
      "tooltip": "Nouveaux visiteurs à configurer dans votre système. Associez-les à des aéronefs existants ou créez de nouvelles entrées."
    },
    "needsRouting": {
      "title": "ATTRIBUER UN EMPLACEMENT",
      "tooltip": "Arrivées nécessitant une affectation de stationnement. Choisissez un hangar ou un tarmac pour chacune."
    },
    "snoozed": {
      "count": "Répétés ({{count}})",
      "tooltip": "Éléments temporairement masqués. Ils réapparaîtront dans votre boîte de réception à la fin de la période de report.",
      "snoozedUntil": "Reporté jusqu'au {{date}}"
    }
  },
  "actionTypeGroup": {
    "urgencyLabels": {
      "now": "MAIN",
      "today": "AUJ."
    },
    "itemCount": "{{count}} élément (réduit)",
    "noItems": "Aucun élément dans ce groupe"
  },
  "bulkActions": {
    "selected": "{{count}} sélectionné(s)",
    "breakdown": "({{quarantineCount}} inconnu(s), {{tripCount}} vol(s))",
    "mapAllTo": "Tout associer à...",
    "snoozeAll": "Tout suspendre",
    "buttons": {
      "mapToAircraft": "Associer à l'aéronef",
      "assignLocation": "Attribuer lieu"
    }
  },
  "assignDropdown": {
    "assignTo": "Attribuer à...",
    "searchPlaceholder": "Rechercher...",
    "hangarsSection": "HANGARS",
    "rampsSection": "TARMACS",
    "tooSmall": "Trop petit",
    "noDimensions": "Aucune dimension",
    "noMatchingLocations": "Aucun lieu correspondant",
    "noLocationsAvailable": "Aucun lieu disponible",
    "dimensions": {
      "width": "{{width}}'L",
      "depth": "{{depth}}'D",
      "height": "{{height}}'H"
    }
  },
  "snooze": {
    "title": "Pause jusqu'à",
    "dateFormat": {
      "todayAt": "Aujourd'hui à {{time}}",
      "tomorrowAt": "Demain à {{time}}"
    }
  },
  "messages": {
    "mapped": "Associé {{tailNumber}} → {{aircraftName}}",
    "assigned": "Assigné {{tailNumber}} à {{locationName}}",
    "snoozed": "Mis en pause {{tailNumber}}",
    "unsnoozed": "Rappel réactivé pour {{tailNumber}}",
    "bulkSnoozed": "{{count}} éléments mis en pause",
    "bulkMapped": "Associé {{count}} aéronefs à {{aircraftName}}",
    "bulkMappedPartial": "Associés : {{successCount}}/{{totalCount}} ({{failCount}} échoués)",
    "bulkAssignedHangar": "Assigné {{count}} vols à {{locationName}}",
    "bulkAssignedRamp": "Attribué {{count}} vols à {{locationName}}",
    "bulkAssignedHangarPartial": "Attribué {{successCount}}/{{totalCount}} vols (échec : {{sampleFails}}{{moreFails}})",
    "bulkAssignedRampPartial": "{{successCount}}/{{totalCount}} vols assignés (échecs : {{sampleFails}}{{moreFails}})",
    "bulkAssignedHangarFailed": "Échec de l'attribution des vols : {{sampleFails}}{{moreFails}}",
    "bulkAssignedRampFailed": "Échec de l'attribution des vols : {{sampleFails}}{{moreFails}}"
  },
  "errors": {
    "resolveFailed": "Échec de la résolution de {{tailNumber}} : {{error}}",
    "assignFailed": "Échec de l'attribution : {{error}}",
    "snoozeFailed": "Échec du report : {{error}}",
    "unsnoozeFailed": "Échec de la réactivation : {{error}}",
    "bulkResolveFailed": "Échec de la résolution groupée : {{error}}",
    "unknownError": "Erreur inconnue",
    "loadFailed": "Erreur de chargement : {{error}}"
  },
  "emptyStates": {
    "today": {
      "title": "Prêt pour aujourd'hui !",
      "message": "Aucune arrivée ne nécessite d'attribution d'emplacement.",
      "laterThisWeek": "{{count}} arrivées plus tard cette semaine",
      "newTailsToSetup": "{{count}} nouveaux appareils à configurer",
      "previewThisWeek": "Aperçu de la semaine",
      "setupNewTails": "Nouveaux appareils"
    },
    "tomorrow": {
      "title": "Rien de prévu pour demain",
      "message": "Revenez plus tard ou consultez toutes les arrivées.",
      "viewAll": "Tout voir"
    },
    "week": {
      "title": "Libre pour la semaine",
      "message": "Tous les arrivées ont été assignées à un stationnement.",
      "setupNewTails": "Configurer {{count}} nouveaux appareils"
    },
    "all": {
      "title": "Vous êtes à jour !",
      "message": "Aucun élément ne requiert votre attention pour le moment."
    }
  },
  "quarantineCard": {
    "noTypeHint": "Type non défini",
    "buttons": {
      "matchTo": "Associer à {{type}}",
      "findAircraft": "Rechercher aéronef",
      "later": "+ tard"
    },
    "labels": {
      "searchAircraft": "Rechercher un aéronef..."
    },
    "tooltips": {
      "searchForType": "Rechercher « {{type}} » dans la base de données aéronefs"
    }
  },
  "tripCard": {
    "buttons": {
      "later": "+ tard"
    },
    "tooltips": {
      "aircraftTooLarge": "Aéronef trop grand",
      "mostUsedLocation": "Lieu le plus utilisé ({{count}} affectations)",
      "assignTo": "Attribuer à {{name}}",
      "moreLocations": "Plus de sites"
    }
  }
}
